import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { Button, Col, Row, Form, Card, Table, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import './style.css';
import AlertMessage from '../../components/Alert';
import { useParams } from 'react-router-dom';
import { Trash, Plus, X, ArrowReturnLeft } from 'react-bootstrap-icons';
import Draggable from 'react-draggable';
import { Autocomplete, TextField, Box, Modal } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Viewer, Worker } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'
import InputMask from 'react-input-mask';

export function EditarReaproveitamentoAdm() {

    const { indexAso } = useParams()

    const [isLoading, setIsLoading] = useState(true);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [exames, setExames] = useState([]);
    const [show, setShow] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [trabalhador, setTrabalhador]: any = useState(null);
    const [examesReaproveitados, setExamesReaproveitados]: any = useState([]);
    const [examesRetornados, setExamesRetornados] = useState<any[]>([]);
    const [examesNaoInclusos, setExamesNaoInclusos] = useState<any[]>([]);
    const [examesQuarentena, setExamesQuarentena]: any = useState([]);
    const [examesTabelaBalcao, setExamesTabelaBalcao]: any = useState([]);
    const [filter, setFilter] = useState('');
    const [funcoes, setFuncoes]: any = useState([]);
    const [funcoesSelecionadas, setFuncoesSelecionadas]: any = useState([]);
    const [novoExame, setNovoExame] = useState({ nome: '', data_realizacao: '', valor_total: '' });
    const [mostrarNovoExame, setMostrarNovoExame] = useState(false);
    const [exameSelecionado, setExameSelecionado]: any = useState();
    const [pdfFile, setPdfFile]: any = useState();
    const [viewPdfFile, setViewPdfFile]: any = useState();
    const [showHelpModal, setShowHelpModal] = useState(false);
    const [pdfFiles, setPdfFiles] = useState([])
    const [examesLoaded, setExamesLoaded] = useState(false);
    const [liberado, setLiberado] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            await loadExames();
            setExamesLoaded(true);
            await loadFunctions();
            await loadTabelaBalcao();
        };
        fetchData();
    }, [indexAso]);

    useEffect(() => {
        // Verifica se trabalhador.id está disponível antes de carregar os arquivos
        const fetchArquivos = async () => {
            try {
                const response = await api.get(`buscar-arquivos-reaproveitamento/${indexAso}`);
                // Atualize o estado com os arquivos recebidos
                setPdfFiles(response.data.data);
            } catch (error) {
                console.error('Erro ao buscar os Arquivos: ', error);
            }
        };

        fetchArquivos();
    }, [trabalhador?.id]);

    const newPlugin = defaultLayoutPlugin()

    const handlePdfSubmit = (pdfBase64: string) => {
        setPdfFile(pdfBase64);
        setViewPdfFile(true);
    };

    const handleCloseDraggable = () => setShow(false);
    const handleShowDraggable = () => setShow(true);
    const handleCloseHelpModal = () => {
        setShowHelpModal(false);
    };

    const handleFilterChange = (event: any) => {
        setFilter(event.target.value.toLowerCase());
    };

    const filteredExames = examesTabelaBalcao.filter((exame: any) =>
        (exame.nome ? exame.nome.toLowerCase() : '').includes(filter)
    );

    const handleListFunction = async (inputValue: any) => {
        if (inputValue.length > 3) {
            const response = await api.get(`funcionarios/buscar-funcao/${inputValue}`);
            const responseData = response.data;
            setFuncoes(responseData);
        } else {
            setFuncoes([]);
        }
    };

    const handleListExams = async (inputValue: any) => {
        if (inputValue.length >= 3) {
            const response = await api.get(`listar-base-exames/${inputValue}`);
            setExames(response.data)
        } else {
            setExames([])
        }
    }

    const handleAddExame = () => {
        setMostrarNovoExame(true);
    };

    const handleNovoExameChange = (field: string, value: string) => {
        setNovoExame({ ...novoExame, [field]: value });
    };

    const handleSaveExame = async () => {
        try {
            const exameJaReaproveitado = examesReaproveitados.some(
                (exame: any) => exame.id_exame === exameSelecionado.id
            );

            if (exameJaReaproveitado) {
                setAlert({
                    show: true,
                    message: "Exame já adicionado.",
                    variant: "warning",
                });
                const input = document.getElementById('exameSelecionado') as HTMLInputElement;
                if (input) input.focus();
                return;
            }

            if (!exameSelecionado || !exameSelecionado.id) {
                setAlert({
                    show: true,
                    message: "Selecione um exame.",
                    variant: "warning",
                });
                const input = document.getElementById('exameSelecionado') as HTMLInputElement;
                if (input) input.focus();
                return;
            }

            if (!novoExame.valor_total) {
                setAlert({
                    show: true,
                    message: "O campo Valor Total é obrigatório.",
                    variant: "warning",
                });
                const input = document.getElementById('novoExame-valor_total') as HTMLInputElement;
                if (input) input.focus();
                return;
            }

            if (!novoExame.data_realizacao) {
                setAlert({
                    show: true,
                    message: "O campo Data de Realização é obrigatório.",
                    variant: "warning",
                });
                const input = document.getElementById('novoExame-data_realizacao') as HTMLInputElement;
                if (input) input.focus();
                return;
            }

            const payload = {
                indexAso: indexAso,
                id_exame: exameSelecionado.id,
                id_trabalhador: trabalhador.id,
                valor_total: parseStringToNumber(novoExame.valor_total),
                data_realizacao: novoExame.data_realizacao,
            };

            const response = await api.post(`salvar-exame-reaproveitamento`, payload);

            loadExames();
            clearExam();
            setMostrarNovoExame(false);
        } catch (error) {
            console.error(error);
        }
    };

    const handleDeleteExam = async (id: number) => {
        try {
            const response = await api.post(`exluir-exame-reaproveitamento/${id}`)
            loadExames()
        } catch (error) {
            console.error(error)
        }
    }

    const handleDeleteTempExam = async (id: number) => {
        try {
            const response = await api.post(`excluir-temp-exame-aso/${id}`)
            if (response.status == 200) {
                loadExames();
            }
        } catch (error) {
            console.error(error)
        }
    }

    const handleSubmit = async () => {
        try {
            if (examesQuarentena.length > 0) {
                setAlert({
                    show: true,
                    message: "Reaproveitamento não pode ser liberado caso haja exames em quarentena",
                    variant: "danger",
                });
            }
            else if (funcoesSelecionadas.length === 0) {
                setAlert({
                    show: true,
                    message: "Selecione ao menos uma função para continuar.",
                    variant: "warning",
                });

                const input = document.getElementById('autocomplete-funcoes') as HTMLInputElement;
                if (input) {
                    input.focus();
                }

            }
            else {
                const data = {
                    indexAso: indexAso,
                    funcoesReaproveitamento: funcoesSelecionadas
                };
                const response = await api.post(`liberar-reaproveitamento`, { data });

                // Verifica a resposta do servidor
                if (response.status === 200) {
                    setLiberado(true);
                    setAlert({
                        show: true,
                        message: "Reaproveitamento liberado!",
                        variant: "success",
                    });

                    // Redireciona após 1 segundo
                    setTimeout(() => {
                        navigate('/reaproveitamentos');
                    }, 1000);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const clearExam = () => {
        setExameSelecionado('')
        novoExame.nome = ''
        novoExame.data_realizacao = ''
        novoExame.valor_total = ''
    }

    const formatDate = (isoDate: any) => {
        const date = new Date(isoDate);

        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Meses começam do 0
        const year = date.getUTCFullYear();

        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');

        return `${day}/${month}/${year} às ${hours}:${minutes}:${seconds}`;
    }



    const transformarPreco = (valor: any) => {
        const valorDividido = valor / 100;
        return valorDividido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    const parseStringToNumber = (input: string): number => {
        const trimmedInput = input.trim();

        const cleanedInput = trimmedInput.replace(/[.,]/g, '');

        const result = parseFloat(cleanedInput);

        // Verifica se o resultado é um número válido
        if (isNaN(result)) {
            throw new Error('A string fornecida não pode ser convertida em um número.');
        }

        return result;
    }

    const loadFunctions = async () => {
        try {
            const response = await api.get(`buscar-funcoes-reaproveitamento/${indexAso}`);
            const funcoesTrabalhador = response.data.funcoesTrabalhador.map((funcao: any) => ({
                id: funcao.ateBaseFuncao.id,
                nome: funcao.ateBaseFuncao.nome,
                cbo: funcao.ateBaseFuncao.cbo,
            }));
            setFuncoesSelecionadas(funcoesTrabalhador);
            setIsDataLoaded(true);
        } catch (error) {
            console.error(error);
        }
    };

    const buscarExamePorFuncaoSelecionada = async (funcoesSelecionadas: any) => {
        try {
            if (funcoesSelecionadas && funcoesSelecionadas.length > 0 && trabalhador) {
                for (const funcaoSelecionada of funcoesSelecionadas) {
                    const response = await api.get(`buscar-exame-por-funcao-selecionada/${funcaoSelecionada.id}/${trabalhador.id}`);

                    console.log("🚀 ~ buscarExamePorFuncaoSelecionada ~ response:", response.data)

                    if ((response && response.data) && examesReaproveitados) {
                        const reaproveitamentos = response.data.reaproveitamentos ?? [];
                        const naoInclusos = response.data.examesNaoInclusos ?? [];

                        for (const exameRetornado of reaproveitamentos) {
                            const exameEncontrado = examesReaproveitados.find((exame: any) => exame.id === exameRetornado.id);

                            if (!exameEncontrado) {
                                naoInclusos.push(exameEncontrado);
                            } else {
                                setExamesRetornados((prevState) =>
                                    prevState.some((exame) => exame.exameId === exameEncontrado.id)
                                        ? prevState
                                        : [...prevState, { exameId: exameEncontrado.id, presente: true }]
                                );
                            }
                        }
                        for (const exameNaoIncluso of naoInclusos) {
                            setExamesRetornados((prevState) =>
                                prevState.some((exame) => exame.exameId === exameNaoIncluso.id)
                                    ? prevState
                                    : [...prevState, { exameId: exameNaoIncluso.id, presente: false }]
                            );
                            setExamesNaoInclusos((prevState: any) => [
                                ...prevState,
                                exameNaoIncluso
                            ]);
                        }
                    }
                }
            }
        } catch (error) {
            console.error("Erro ao buscar exame por função: ", error);
        }
    }

    const loadExames = async () => {
        try {
            const dados = await api.get(`buscar-exames-reaproveitamento/${indexAso}`);
            setExamesReaproveitados(dados.data.reaproveitamentos)
            setTrabalhador(dados.data.trabalhador)
            setExamesQuarentena(dados.data.examesQuarentena)
            setLiberado(dados.data.statusReaproveitamento.liberado)
            setIsDataLoaded(true);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const loadTabelaBalcao = async () => {
        try {
            const response = await api.get(`buscar-tabela-balcao`);
            setExamesTabelaBalcao(response.data);
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Row>
                    {/* Coluna Esquerda */}
                    <Col md={6}>
                        <Card style={{
                            height: '810px',
                            border: '1px solid #0d6efd',
                            borderRadius: '8px',
                            margin: '10px 0', // Ajusta a margem para cima e para baixo
                            backgroundColor: viewPdfFile ? '#f0f0f0' : '#fff',
                            width: '100%' // Garante que o Card ocupe 100% da largura disponível
                        }}>
                            {viewPdfFile && (
                                <Card.Header style={{
                                    position: 'relative',
                                    backgroundColor: '#c0c7cf',
                                    borderBottom: '1px solid #0d6efd',
                                    height: '5%',
                                }}>
                                    <X
                                        onClick={() => setViewPdfFile(false)}
                                        style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer',
                                            fontSize: '2rem',
                                            color: 'gray',
                                        }}
                                    />
                                </Card.Header>
                            )}
                            <Card.Body style={{ overflowY: 'auto', padding: '0' }}> {/* Remove o padding para usar a largura completa */}
                                <div style={{ width: '100%' }}>
                                    {!viewPdfFile ? (
                                        <div>
                                            <Card.Header style={{
                                                position: 'relative',
                                                backgroundColor: '#0d6efd',
                                                borderBottom: '1px solid #0d6efd',
                                                height: '40px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '0 10px',
                                            }}>
                                                <ArrowBackIcon
                                                    onClick={() => navigate('/reaproveitamentos')}
                                                    sx={{
                                                        cursor: 'pointer',
                                                        fontSize: '1.5rem',
                                                        color: 'white !important',
                                                    }}
                                                />
                                                <div style={{
                                                    flex: 1,
                                                    textAlign: 'center',
                                                    fontSize: '1rem',
                                                    color: '#fff',
                                                }}>
                                                    DOCUMENTOS ASO
                                                </div>
                                            </Card.Header>
                                            <div style={{ padding: '10px', boxSizing: 'border-box' }}>
                                                {pdfFiles.map((file: any) => (
                                                    <Card
                                                        key={file.key}
                                                        onClick={() => handlePdfSubmit(file.data)}
                                                        style={{
                                                            height: '50px',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            border: '1px solid #0d6efd',
                                                            borderRadius: '8px',
                                                            backgroundColor: '#f8f9fa',
                                                            color: '#0d6efd',
                                                            marginTop: '10px',
                                                            padding: '8px',
                                                            boxSizing: 'border-box',
                                                        }}
                                                    >
                                                        <h5 style={{ margin: '0' }}>{file.name}</h5>
                                                    </Card>
                                                ))}
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{
                                            height: '100%',
                                            width: '100%'
                                        }}>
                                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                                                {pdfFile ? (
                                                    <Viewer fileUrl={`data:application/pdf;base64,${pdfFile}`} plugins={[newPlugin]} />
                                                ) : (
                                                    <div>Carregando PDF</div>
                                                )}
                                            </Worker>
                                        </div>
                                    )}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>


                    {/* Coluna Direita */}
                    <Col md={6}>
                        <Card style={{
                            height: '300px',
                            border: '1px solid #0d6efd',
                            borderRadius: '8px',
                            margin: '10px'
                        }}>
                            <Card.Body style={{ overflowY: 'auto' }}>
                                <Card.Title>Dados do Funcionário</Card.Title>
                                <Form.Group controlId="formNome" className="mb-2">
                                    <Form.Label>Nome do Funcionário</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="nome"
                                        value={trabalhador?.nome || ''}
                                        disabled
                                        size="sm"
                                        style={{
                                            padding: '0.2rem 0.4rem',
                                            fontSize: '0.75rem'
                                        }}
                                    />
                                </Form.Group>
                                <Row className="mb-2">
                                    <Col md={6}>
                                        <Form.Group controlId="formCpf">
                                            <Form.Label>CPF</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="cpf"
                                                value={trabalhador?.cpf || ''}
                                                disabled
                                                size="sm"
                                                style={{
                                                    padding: '0.2rem 0.4rem',
                                                    fontSize: '0.75rem'
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="formCelular" className="mb-2">
                                            <Form.Label>Celular</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="celular"
                                                value={trabalhador?.celular || ''}
                                                disabled
                                                size="sm"
                                                style={{
                                                    padding: '0.2rem 0.4rem',
                                                    fontSize: '0.75rem'
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        {isDataLoaded ? (
                                            <Form.Group controlId="formFuncao">
                                                <Form.Label>Função</Form.Label>
                                                <Autocomplete
                                                    multiple
                                                    options={funcoes}
                                                    getOptionLabel={(option: any) => option ? option.nome : ""}
                                                    value={funcoesSelecionadas}
                                                    disabled={liberado}
                                                    onChange={(_, newValue: any) => {
                                                        setFuncoesSelecionadas(newValue);
                                                        buscarExamePorFuncaoSelecionada(newValue);
                                                    }}
                                                    id="autocomplete-funcoes"
                                                    onInputChange={(event, inputValue) => {
                                                        handleListFunction(inputValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            size="small"
                                                            style={{
                                                                padding: '0.2rem 0.4rem',
                                                                fontSize: '0.75rem'
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        ) : (
                                            <p>Carregando dados...</p>
                                        )}
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        <Card style={{
                            height: '500px',
                            border: '1px solid #0d6efd',
                            borderRadius: '8px',
                            margin: '10px'
                        }}>
                            <Card.Body style={{
                                overflowY: 'auto',
                                maxHeight: '100%'
                            }}>
                                <Row className="mb-3">
                                    <Col>
                                        <Card.Title>Exames Incluídos</Card.Title>
                                    </Col>
                                    <Col className="text-end">
                                        <Button variant="primary" onClick={handleShowDraggable} size="sm">
                                            Tabela Balcão
                                        </Button>
                                    </Col>
                                </Row>
                                {!liberado && (
                                    <Row className="mb-2">
                                        <Col md={6}>
                                            <Button variant="success" size="sm" onClick={handleAddExame}>
                                                <Plus /> Novo exame
                                            </Button>
                                        </Col>
                                    </Row>)}


                                {mostrarNovoExame && (
                                    <Row className="mb-1">
                                        <Col md={6}>
                                            <Form.Group controlId="formNovoExameNome">
                                                <Autocomplete
                                                    options={exames}
                                                    id="exameSelecionado"
                                                    getOptionLabel={(option: any) => option ? option.nome : ""}
                                                    value={exameSelecionado}
                                                    onChange={(event: any, newValue: any) => {
                                                        setExameSelecionado(newValue);
                                                    }}
                                                    onInputChange={(event, inputValue) => {
                                                        handleListExams(inputValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            size="small"
                                                            style={{
                                                                padding: '0.2rem 0.4rem',
                                                                fontSize: '0.75rem'
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group controlId="formNovoExameData">
                                                <InputMask
                                                    mask="99/99/9999"
                                                    id="novoExame-data_realizacao"
                                                    value={novoExame.data_realizacao}
                                                    onChange={(e: any) => handleNovoExameChange('data_realizacao', e.target.value)}
                                                >
                                                    {(inputProps: any) => (
                                                        <TextField
                                                            {...inputProps}
                                                            type="text"
                                                            placeholder="Data de Realização"
                                                            size="small"
                                                            style={{
                                                                padding: '0.2rem 0.4rem',
                                                                fontSize: '0.75rem'
                                                            }}
                                                        />
                                                    )}
                                                </InputMask>
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group controlId="formNovoExameValor">
                                                <TextField
                                                    type="text"
                                                    id="novoExame-valor_total"
                                                    placeholder="Valor"
                                                    value={novoExame.valor_total}
                                                    onChange={(e) => handleNovoExameChange('valor_total', e.target.value)}
                                                    size="small"
                                                    style={{
                                                        padding: '0.2rem 0.4rem',
                                                        fontSize: '0.75rem'
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={1} className="d-flex align-items-center justify-content-center">
                                            <Button
                                                variant="success"
                                                aria-label="Salvar exame"
                                                size="sm"
                                                onClick={handleSaveExame}
                                                style={{
                                                    padding: '0.2rem 0.4rem',
                                                    fontSize: '0.75rem',
                                                    marginRight: '0.4rem'
                                                }}
                                            >
                                                Adicionar
                                            </Button>
                                        </Col>
                                    </Row>
                                )}

                                <Row className="mb-2">
                                    <Col md={6} className='col-padding-sides'>
                                        <Form.Label>Nome do Exame</Form.Label>
                                    </Col>
                                    <Col md={3} className='col-padding-sides'>
                                        <Form.Label>Data de Realização</Form.Label>
                                    </Col>
                                    <Col md={2} className='col-padding-sides'>
                                        <Form.Label>Valor</Form.Label>
                                    </Col>
                                </Row>

                                {examesReaproveitados.map((exame: any, index: any) => {
                                    let presente;
                                    if (examesRetornados.length > 0) {
                                        const exameRetornado = examesRetornados.find((item: any) => item.exameId === exame.id);
                                        if (exameRetornado) presente = true;
                                    }
                                    return (
                                        <>
                                            <Row key={index} className="mb-1">
                                                <Col md={6} className='col-padding-sides'>
                                                    <div className="exam-container">
                                                        <div className="exam-content">
                                                            <div className="exam-name">
                                                                {exame.ateBaseExames.nome || ''}
                                                            </div>
                                                            <div className="exam-checkbox-container">
                                                                {presente && (
                                                                    <label className={`custom-checkbox ${presente ? '' : 'invalid'}`}>
                                                                        <input type="checkbox" checked readOnly />
                                                                        <span></span>
                                                                    </label>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col md={3} className='col-padding-sides'>
                                                    <div className="exam-container">
                                                        {exame.data_realizacao || ''}
                                                    </div>
                                                </Col>
                                                <Col md={2} className='col-padding-sides'>
                                                    <Form.Group controlId={`formExameValor-${index}`}>
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id={`tooltip-exame-valor-${index}`}>
                                                                    Valor referente à tabela balcão padrão
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <Form.Control
                                                                type="text"
                                                                name={`exameValor-${index}`}
                                                                value={transformarPreco(exame.valor_total) || ''}
                                                                disabled
                                                                size="sm"
                                                                style={{ fontSize: '0.8rem' }}
                                                            />
                                                        </OverlayTrigger>
                                                    </Form.Group>
                                                </Col>
                                                {!liberado && (
                                                    <Col md={1} className="d-flex align-items-center justify-content-center col-padding-sides">
                                                        <Button
                                                            variant="danger"
                                                            aria-label="Excluir exame"
                                                            onClick={() => handleDeleteExam(exame.id)}
                                                            size="sm"
                                                            style={{
                                                                padding: '0.2rem 0.4rem',
                                                                fontSize: '0.75rem'
                                                            }}
                                                        >
                                                            <Trash />
                                                        </Button>
                                                    </Col>
                                                )}
                                            </Row>
                                        </>
                                    );
                                })}
                                <hr />
                                {examesNaoInclusos.length > 0 && examesNaoInclusos.map((exame: any, index: any) => {
                                    let presente;
                                    if (examesRetornados.length > 0) {
                                        const exameRetornado = examesRetornados.find((item: any) => item.exameId === exame.id);
                                        if (exameRetornado) presente = true;
                                    }
                                    return (
                                        <>
                                            <Row key={index} className="mb-1">
                                                <Col md={6} className='col-padding-sides'>
                                                    <div className="exam-container">
                                                        <div className="exam-content">
                                                            <div className="exam-name">
                                                                {exame.ateBaseExames.nome || ''}
                                                            </div>
                                                            <div className="exam-checkbox-container">
                                                                {presente && (
                                                                    <label className={'custom-checkbox invalid'}>
                                                                        <input type="checkbox" checked readOnly />
                                                                        <span></span>
                                                                    </label>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                                {/* <Col md={3} className='col-padding-sides'>
                                                    <div className="exam-container">
                                                        {exame.data_realizacao || ''}
                                                    </div>
                                                </Col>
                                                <Col md={2} className='col-padding-sides'>
                                                    <Form.Group controlId={`formExameValor-${index}`}>
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id={`tooltip-exame-valor-${index}`}>
                                                                    Valor referente à tabela balcão padrão
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <Form.Control
                                                                type="text"
                                                                name={`exameValor-${index}`}
                                                                value={transformarPreco(exame.valor_total) || ''}
                                                                disabled
                                                                size="sm"
                                                                style={{ fontSize: '0.8rem' }}
                                                            />
                                                        </OverlayTrigger>
                                                    </Form.Group>
                                                </Col>
                                                {!liberado && (
                                                    <Col md={1} className="d-flex align-items-center justify-content-center col-padding-sides">
                                                        <Button
                                                            variant="danger"
                                                            aria-label="Excluir exame"
                                                            onClick={() => handleDeleteExam(exame.id)}
                                                            size="sm"
                                                            style={{
                                                                padding: '0.2rem 0.4rem',
                                                                fontSize: '0.75rem'
                                                            }}
                                                        >
                                                            <Trash />
                                                        </Button>
                                                    </Col>
                                                )} */}
                                            </Row>
                                        </>
                                    );
                                })}
                                {examesQuarentena.map((exame: any, index: any) => (
                                    <Row key={index} className="mb-1">
                                        <Col md={6}>
                                            <InputGroup>
                                                <Form.Control
                                                    type="text"
                                                    name={`exameNome-${index}`}
                                                    value={exame.nome || ''}
                                                    disabled
                                                    size="sm"
                                                    style={{
                                                        fontSize: '0.8rem',
                                                        borderColor: 'red',
                                                        backgroundColor: '#f8f9fa'
                                                    }}
                                                />
                                                <InputGroup.Text
                                                    style={{
                                                        cursor: 'pointer',
                                                        fontSize: '0.8rem',
                                                        backgroundColor: '#0d6efd',
                                                        color: '#fff',
                                                        borderRadius: '50%',
                                                        marginLeft: '0.5rem',
                                                        width: '30px',
                                                        height: '30px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                    onClick={() => setShowHelpModal(true)}
                                                >
                                                    ?
                                                </InputGroup.Text>
                                            </InputGroup>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group controlId={`formExameData-${index}`}>
                                                <Form.Control
                                                    type="text"
                                                    name={`exameData-${index}`}
                                                    value={exame.data_realizacao || ''}
                                                    size="sm"
                                                    style={{ fontSize: '0.8rem' }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2} className="d-flex align-items-center justify-content-center">
                                            <span>Quarentena</span>
                                        </Col>
                                        <Col md={1} className="d-flex align-items-center justify-content-center">
                                            {!liberado && (
                                                <Button
                                                    variant="danger"
                                                    aria-label="Excluir exame"
                                                    onClick={() => handleDeleteTempExam(exame.id)}
                                                    size="sm"
                                                    style={{
                                                        padding: '0.2rem 0.4rem',
                                                        fontSize: '0.75rem'
                                                    }}
                                                >
                                                    <Trash />
                                                </Button>
                                            )}

                                        </Col>
                                    </Row>
                                ))}
                                {!liberado && (
                                    <Row className="mb-3">
                                        <Col md={12} className="d-flex justify-content-center">
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                onClick={handleSubmit}
                                                style={{
                                                    width: '40%',
                                                    marginTop: '0.8rem'
                                                }}
                                            >
                                                Aprovar Reaproveitamento
                                            </Button>
                                        </Col>
                                    </Row>
                                )}

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
            <Modal
                open={showHelpModal}
                onClose={handleCloseHelpModal}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '400px',
                    maxWidth: '90%',
                    maxHeight: '80%'
                }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <h4>EXAME EM QUARENTENA</h4>
                        <br />
                        <p>
                            Exames marcados em vermelho são aqueles que não se encontram em nossa base.
                            <br />
                            As tratativas para estes casos são:
                        </p>
                        <p>
                            <strong>Primeiro caso</strong>: O exame em questão possui um nome diferente ao presente em nossa base.  Ex: o exame RAIO X está presente em nossa base como RX.
                            <br />
                            Este caso pode ser resolvido com a exclusão do exame em vermelho e a adição do presente em nossa base
                        </p>
                        <p>
                            <strong>Segundo caso: </strong> O exame em questão não existe. Neste caso, é necessária a exclusão do exame em vermelho.
                        </p>
                        <p>
                            <strong>Terceiro caso: </strong> O exame não existe em nossa base. Neste caso, é necessária a adição do exame em nosso sistema
                        </p>
                        <b>Link para cadastro do exame</b>
                        <a href='http://devweb.softwareatento.com.br/config/exames' target='_blank' rel="noopener noreferrer">Clique aqui</a>
                    </Box>

                </Box>
            </Modal>
            {show && (
                <Draggable handle=".draggable-handle">
                    <Card style={{
                        width: '30rem',
                        height: '50vh',
                        position: 'absolute',
                        top: '20%',
                        left: '30%',
                        zIndex: 9999
                    }}>
                        <Card.Header className="draggable-handle" style={{
                            cursor: 'move',
                            position: 'relative',
                            paddingRight: '2.5rem'
                        }}>
                            Tabela Balcão
                            <X
                                onClick={handleCloseDraggable}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                    fontSize: '1.50rem',
                                    color: 'gray'
                                }}
                            />
                        </Card.Header>
                        <Card.Body style={{
                            overflowY: 'auto',
                            maxHeight: 'calc(100% - 60px)'
                        }}>
                            <Form.Group className="mb-3">
                                <Form.Control
                                    type="text"
                                    placeholder="Buscar exame"
                                    value={filter}
                                    onChange={handleFilterChange}
                                />
                            </Form.Group>
                            <Table striped bordered hover size="sm" style={{ width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th style={{
                                            maxWidth: '65%',
                                            whiteSpace: 'normal',
                                            wordWrap: 'break-word'
                                        }}>Exame</th>
                                        <th style={{ whiteSpace: 'nowrap' }}>Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredExames.map((exame: any, index: any) => (
                                        <tr key={index}>
                                            <td style={{
                                                maxWidth: '65%',
                                                whiteSpace: 'normal',
                                                wordWrap: 'break-word'
                                            }}>{exame.nome}</td>
                                            <td style={{
                                                whiteSpace: 'nowrap',
                                                textAlign: 'right'
                                            }}>{transformarPreco(exame.valor_venda)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Draggable>
            )}
        </div>


    );
}